<template>
  <div v-cloak  v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Create Instance Tag"
      :visible.sync="addDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      size="small">

      <el-form
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="Tag: "  required>
          <el-input v-model="instanceTagDO.tagName" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Description: "  >
          <el-input v-model="instanceTagDO.description" size="small" ></el-input>
        </el-form-item>
        

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="addDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

  export default {
    components: {

    },
    props:  {
      instanceParentId:{
        type: String,
        required: true,
        default: () => ''
      },
      abstractTagId:{
        type: String,
        required: true,
        default: () => ''
      }
   },
    data(){
      return{
        addDialogVisible: false,
        instanceTagDO:{
          tagName:'',
          appKey: this.appKey,
          parentId: this.instanceParentId,
          dataTagId:this.abstractTagId,
          description:'',
        },
        dataLoading: false
      }
    },
    computed: {
    },
    created(){
    },


    methods: {
      showDialog(){
        this.instanceTagDO = { appKey: this.appKey, parentId: this.instanceParentId,dataTagId:this.abstractTagId};
        this.addDialogVisible = true;
      },
      hideDialog(){
        this.instanceTagDO = { appKey: this.appKey, parentId: this.instanceParentId,dataTagId:this.abstractTagId};
        this.addDialogVisible = false;
      },
      save(){
        let url = this.baseAcsUrl + '/acs/data-instance-tag/add';
        if(!this.instanceTagDO.tagName){
          this.$message.warning("tagName can't be empty");
          return;
        }

        this.dataLoading = true;
        this.instanceTagDO.parentId = this.instanceParentId === '0' ? null : this.instanceParentId;
        this.instanceTagDO.dataTagId = this.abstractTagId === '0' ? null : this.abstractTagId;
        this.http.post(url,this.instanceTagDO).then(resp =>{
          this.$message.success('Successful operation ');
          this.addDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");

        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/tag/dialog/add_instance_tag.vue